import React from 'react';
import chartPresets from '@meitu/saas-editor-core/es/layers/chart-layer/presets';
import { useLocaleStore } from '@/i18n';
import { PanelContainer } from '../../components';
import './style.less';

type Props = {
    onExit: () => void;
    onAddChart: (presetId: string) => void;
};

const ChartSubPanel: React.FC<Props> = ({ onExit, onAddChart }) => {
    const { $t } = useLocaleStore();
    const series = [
        {
            key: 'bar',
            title: $t((v) => v.collapse.moreCollapse.chartTool.barName),
            presets: chartPresets.filter(
                (preset) => preset.type.includes('bar') && !preset.type.includes('horizontal'),
            ),
        },
        {
            key: 'horizontalBar',
            title: $t((v) => v.collapse.moreCollapse.chartTool.horizontalBarName),
            presets: chartPresets.filter((preset) => preset.type.includes('bar') && preset.type.includes('horizontal')),
        },
        {
            key: 'line',
            title: $t((v) => v.collapse.moreCollapse.chartTool.lineName),
            presets: chartPresets.filter((preset) => preset.type.includes('line')),
        },
        {
            key: 'pie',
            title: $t((v) => v.collapse.moreCollapse.chartTool.pieName),
            presets: chartPresets.filter((preset) => preset.type.includes('pie')),
        },
    ];
    return (
        <PanelContainer
            className="chart-sub-panel"
            title={$t((v) => v.collapse.moreCollapse.chartTool.title)}
            onExit={onExit}
        >
            <div className="chart-sub-panel-content">
                {series.map(({ key, title, presets }) => (
                    <div className="chart-preset-series" key={key}>
                        <div className="chart-preset-list-title">{title}</div>
                        <ul className="chart-preset-list">
                            {presets.map((preset) => (
                                <li key={preset.id} className="chart-preset" onClick={() => onAddChart(preset.id)}>
                                    <div style={{ backgroundImage: `url("${preset.preview}")` }}></div>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </PanelContainer>
    );
};

ChartSubPanel.displayName = 'ChartSubPanel';

export default ChartSubPanel;
